import React from "react";

import { graphql } from "gatsby";

import RichText from "cms/components/RichText";
import Text from "cms/components/Text/Text.component";
import MicrosoftLogo from "cms/images/MS_startups_logo.png";
import UizardLogo from "cms/images/uizard_logo_yellow.png";

import {
  Container,
  Content,
  HeadlineContainer,
  Illustration,
  IllustrationContainer,
  Illustrations,
  Link,
  Pitch,
} from "./MicrosoftStartupHeroBannerBlock.styles";

export interface MicrosoftStartupHeroBannerBlockProps
  extends Queries.SanityMicrosoftStartupHeroBannerBlock {}

const MicrosoftStartupHeroBannerBlock: React.FC<
  MicrosoftStartupHeroBannerBlockProps
> = ({ headline, _rawPitch }) => (
  <Container>
    <Content>
      <HeadlineContainer>
        <Text variant="H1" as="h1" textAlign="center">
          {headline}
        </Text>
      </HeadlineContainer>

      <Pitch>
        <RichText text={_rawPitch} />
      </Pitch>

      <Illustrations>
        <IllustrationContainer>
          <Illustration src={UizardLogo} alt="Uizard light logo" />
        </IllustrationContainer>
        <IllustrationContainer>
          <Link href="https://foundershub.startups.microsoft.com/signup">
            <Illustration
              src={MicrosoftLogo}
              alt="logo Microsoft for Startups Founders Hub"
            />
          </Link>
        </IllustrationContainer>
      </Illustrations>
    </Content>
  </Container>
);

export const query = graphql`
  fragment MicrosoftStartupHeroBannerBlock on SanityMicrosoftStartupHeroBannerBlock {
    _key
    _type
    headline
    _rawPitch(resolveReferences: { maxDepth: 5 })
  }
`;

export default MicrosoftStartupHeroBannerBlock;
